import { render } from "./TemplatePackItem.vue?vue&type=template&id=1b8a7708"
import script from "./TemplatePackItem.vue?vue&type=script&lang=js"
export * from "./TemplatePackItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__